import React from "react";
import withCustomStyles from "./AddressesPart.style";
import AddIcon from "@material-ui/icons/Add";
import { withRouter } from "react-router";
import * as classnames from "classnames";
import { inject, observer } from "mobx-react";
import { withSnackbar } from "notistack";
import { strLimit } from "../utils/HelperUtils";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import _throttle from "lodash/throttle";
import gtmService from "../services/GTMService";
import HomeOutlined from "@material-ui/icons/HomeOutlined";
import BusinessOutlined from "@material-ui/icons/BusinessOutlined";
import { GButton, GChoice } from "./ui";

@inject(["locationStore"])
@inject(["customerStore"])
@observer
class AddressesPart extends React.Component {
  state = {
    selectClicked: false
  };

  handleSelectAddress = _throttle(
    event => {
      const {
        props: {
          location: { pathname },
          history,
          locationStore,
          enqueueSnackbar,
          toggleCollapse,
          handleVendorChange,
          closeModal,
          isModal
        }
      } = this;
      if (event.target.value == locationStore.currentAddress.id) {
        if (isModal) {
          closeModal();
        } else {
          toggleCollapse();
        }
        return;
      }
      this.setState({ selectClicked: true });
      locationStore.selectAddress(
        event.target.value,
        data => {
          gtmService.event(
            "User",
            "Location_selected_from_location_bottom_sheet",
            pathname === "/checkout" ? "From_Checkout_Page" : "From_Home_Page"
          );
          if (isModal) {
            closeModal();
          } else {
            toggleCollapse();
          }
          if (data.vendor_changed) {
            const coords = {
              lat: data.address.location_coordinates.split(",")[0],
              lng: data.address.location_coordinates.split(",")[1],
              location: data.address.pin_address
            };
            handleVendorChange(coords);
          }
          if (data.express_changed && pathname === "/checkout") {
            history.push("/cart");
          }
        },
        () => {
          enqueueSnackbar(
            "We couldn't switch to this address. Check your connection and try again.",
            {
              variant: "error"
            }
          );
        }
      );
    },
    10000,
    { trailing: false }
  );

  addNewAddress = () => {
    const {
      props: {
        history,
        toggleCollapse,
        isModal,
        location: { pathname }
      }
    } = this;
    if (!isModal) {
      toggleCollapse();
    }
    if (pathname === "/checkout" || pathname === "/cart") {
      gtmService.event(
        "User",
        "Add_Address_from_bottom_sheet",
        "From_Checkout_Page"
      );
      history.push("/add-address?redirect=/cart");
    } else {
      gtmService.event(
        "User",
        "Add_Address_from_bottom_sheet",
        "From_Home_Page"
      );
      history.push("/add-address");
    }
  };

  componentWillUnmount() {
    const {
      state: { selectClicked },
      props: { locationStore }
    } = this;
    if (selectClicked) {
      locationStore.getAddresses();
    }
  }

  render() {
    const {
      props: { classes, isModal, locationStore, closeModal },
      handleSelectAddress
    } = this;

    return (
      <div className={classnames(classes.root, { [classes.modal]: isModal })}>
        <div className={classes.head}>
          <h2 className={classes.title}>Where should we deliver?</h2>
          {isModal && (
            <IconButton
              aria-label="Close"
              className={classes.closeButton}
              onClick={closeModal}
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
        <div
          role="radiogroup"
          aria-label="Saved addresses"
          className={classes.list}
        >
          {locationStore.all.map(location => (
            <GChoice
              key={location.id}
              name="header-address"
              value={location.id}
              checked={!!location.is_selected}
              onChange={handleSelectAddress}
              icon={
                /office|work/i.test(location.label || "") ? (
                  <BusinessOutlined />
                ) : (
                  <HomeOutlined />
                )
              }
              title={strLimit(location.label, 24)}
              meta={strLimit(location.single_line_address, 60)}
            />
          ))}
        </div>
        <GButton
          variant="secondary"
          fullWidth
          icon={<AddIcon />}
          onClick={() => this.addNewAddress()}
        >
          Add new address
        </GButton>
      </div>
    );
  }
}

export default withRouter(withSnackbar(withCustomStyles(AddressesPart)));
